module.exports = __webpack_public_path__ + "ed5e90eea30e4c37bf9dd41031311a3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/folder_alpha_gray_2x.png
// module id = 114
// module chunks = 0 1 2 3 4